import api from './api';

const BASE = '/sst';

export const sesionActualSST = () => {
    const ahora = new Date();
    const mes = String(ahora.getMonth() + 1).padStart(2, '0');
    const q = ahora.getDate() <= 15 ? 'Q1' : 'Q2';
    return `${ahora.getFullYear()}-${mes}-${q}`;
};

export const sstService = {
    listarCts: async () => {
        const response = await api.get(`${BASE}/cts`);
        return response.data?.cts || [];
    },

    checklist: async (sesion = null, ct = null) => {
        const params = { sesion: sesion || sesionActualSST() };
        if (ct) params.ct = ct;
        const response = await api.get(`${BASE}/checklist`, { params });
        return response.data;
    },

    responder: async (itemId, respuesta, observaciones = null, sesion = null, ct = null) => {
        const response = await api.post(`${BASE}/responder`, {
            item_id: itemId,
            respuesta,
            observaciones,
            sesion: sesion || sesionActualSST(),
            ct: ct || null,
        });
        return response.data;
    },

    enviarReporte: async (email, sesion = null, ct = null) => {
        const response = await api.post(`${BASE}/reporte/enviar`, {
            email,
            sesion: sesion || null,
            ct: ct || null,
        });
        return response.data;
    },

    historial: async ({ anio = null, mes = null, ct = null } = {}) => {
        const params = {};
        if (anio !== null && anio !== '') params.anio = anio;
        if (mes !== null && mes !== '') params.mes = mes;
        if (ct !== null && ct !== '') params.ct = ct;
        const response = await api.get(`${BASE}/historial`, { params });
        return response.data;
    },

    // Importa el checklist global desde un archivo Excel (aplica a todos los almacenes)
    importarChecklistExcel: async (file) => {
        const formData = new FormData();
        formData.append('file', file);
        const response = await api.post(`${BASE}/checklist/importar-excel`, formData, {
            headers: { 'Content-Type': 'multipart/form-data' },
        });
        return response.data;
    },

    // Restaura el checklist global por defecto (SST_PR_07 - RE08)
    restaurarChecklistDefault: async () => {
        const response = await api.delete(`${BASE}/checklist`);
        return response.data;
    },
};

export const descargarPlantillaChecklistSST = async () => {
    const response = await api.get(`${BASE}/checklist/plantilla`, { responseType: 'blob' });
    const url = window.URL.createObjectURL(new Blob([response.data], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    }));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', 'plantilla_checklist_sst.xlsx');
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
};

export const descargarReporteSST = async (sesion = null, ct = null) => {
    const params = {};
    if (sesion) params.sesion = sesion;
    if (ct) params.ct = ct;
    const response = await api.get(`${BASE}/reporte/descargar`, {
        params,
        responseType: 'blob',
    });
    const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }));
    const link = document.createElement('a');
    link.href = url;
    const ctSlug = (ct || 'general').replace(/\s+/g, '_');
    link.setAttribute('download', `inspeccion_sst_${ctSlug}_${sesion || 'actual'}.pdf`);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
};

export const descargarReporteExcelSST = async (sesion = null, ct = null) => {
    const params = {};
    if (sesion) params.sesion = sesion;
    if (ct) params.ct = ct;
    const response = await api.get(`${BASE}/reporte/descargar-excel`, {
        params,
        responseType: 'blob',
    });
    const url = window.URL.createObjectURL(new Blob([response.data], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    }));
    const link = document.createElement('a');
    link.href = url;
    const ctSlug = (ct || 'general').replace(/\s+/g, '_');
    link.setAttribute('download', `inspeccion_sst_${ctSlug}_${sesion || 'actual'}.xlsx`);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
};

// Excel consolidado con todos los Centros de Trabajo de la inspectoria (una sesión)
export const descargarReporteExcelInspectoriaSST = async (sesion = null) => {
    const params = {};
    if (sesion) params.sesion = sesion;
    const response = await api.get(`${BASE}/reporte/descargar-excel-inspectoria`, {
        params,
        responseType: 'blob',
    });
    const url = window.URL.createObjectURL(new Blob([response.data], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    }));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `inspeccion_sst_toda_inspectoria_${sesion || 'actual'}.xlsx`);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
};
